"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serviceAreaSubTypes = exports.rowsPerPageOptions = exports.physicalityOptions = exports.MANUALLY_SELECTED_AREA_TYPES = exports.occupancyOptions = exports.leaseableOptions = exports.columns = exports.assetTypeToAreaType = exports.areaTypeOptions = exports.areaSubTypeMap = exports.areaCategoryOptions = exports.areaCategoryDescriptions = void 0;
exports.getAreaSubTypes = getAreaSubTypes;
var columns = [
    { name: "BUILDING", uid: "buildingName" },
    { name: "AREA NAME", uid: "areaNumber" },
    { name: "LOCATION", uid: "physicalAddress" },
    { name: "AREA TYPE", uid: "areaType" },
    { name: "AREA CATEGORY", uid: "areaCategory" },
    { name: "AREA SUB TYPE", uid: "areaSubType" },
    { name: "PHYSICALITY", uid: "areaPhysicality" },
    { name: "SIZE (m²)", uid: "areaSize" },
    { name: "LEASEABLE", uid: "isLeaseable" },
    // ATOC-1 C6 — Erik: "I can't see the occupation status?" Derived, never captured.
    { name: "OCCUPANCY", uid: "occupancyStatus" },
    { name: "ESTABLISHED", uid: "establishmentDate" },
    { name: "CREATED", uid: "createdAt" },
    { name: "UPDATED", uid: "updatedAt" },
    { name: "STATUS", uid: "isActive" },
    { name: "ACTIONS", uid: "actions" },
];
exports.columns = columns;
var physicalityOptions = [
    { key: "all", label: "All Types" },
    { key: "Physical", label: "Physical" },
    { key: "Grouped", label: "Grouped" },
];
exports.physicalityOptions = physicalityOptions;
/**
 * ATOC-1 A3/A6: the area types, now the SAME list as the asset types
 * (see assets/constants → buildingTypeOptions). "Hotel & Resort" became "Hospitality"; Mixed Use and
 * Mining were added so the two lists match.
 */
var areaTypeOptions = [
    { key: "all", label: "All Types" },
    { key: "Retail", label: "Retail" },
    { key: "Residential", label: "Residential" },
    { key: "Industrial", label: "Industrial" },
    { key: "Commercial", label: "Commercial" },
    { key: "Hospitality", label: "Hospitality" },
    { key: "Sports & Recreation", label: "Sports & Recreation" },
    { key: "Mixed Use", label: "Mixed Use" },
    { key: "Mining", label: "Mining" },
];
exports.areaTypeOptions = areaTypeOptions;
/**
 * ATOC-1 A5/A7: which area types the user picks by hand.
 *
 * Every other type is derived from the building. Erik: "all types (except for Hospitality, Mixed Use,
 * and Mining), the area type must inherit its type from the building type."
 */
var MANUALLY_SELECTED_AREA_TYPES = ["Hospitality", "Mixed Use", "Mining"];
exports.MANUALLY_SELECTED_AREA_TYPES = MANUALLY_SELECTED_AREA_TYPES;
/**
 * ATOC-1: asset type key → area type label. The two lists are the same set, but the asset side is
 * stored as an enum key and the area side as a label, so inheritance needs this hop.
 */
var assetTypeToAreaType = {
    RESIDENTIAL: "Residential",
    COMMERCIAL: "Commercial",
    INDUSTRIAL: "Industrial",
    MIXED_USE: "Mixed Use",
    RETAIL: "Retail",
    MINING: "Mining",
    HOSPITALITY: "Hospitality",
    SPORTS_RECREATION: "Sports & Recreation",
    // Legacy asset types, still mapped so an un-migrated building can still derive an area type.
    HOTELS: "Hospitality",
    HOTEL: "Hospitality",
    SPORT_CENTRES: "Sports & Recreation",
    OFFICE: "Commercial",
};
exports.assetTypeToAreaType = assetTypeToAreaType;
var leaseableOptions = [
    { key: "all", label: "All" },
    { key: "yes", label: "Leaseable" },
    { key: "no", label: "Not Leaseable" },
];
exports.leaseableOptions = leaseableOptions;
/*
 * ATOC-1 C6, per Erik's clarification. Three states, and the middle one is the point: an area whose
 * tenant has not moved in yet is not available to let, but it is empty today — calling it either
 * "occupied" or "unoccupied" would mislead whoever is looking for space.
 *
 * Choosing any of these implies leasable, since Erik excluded non-leasable areas from the concept.
 */
var occupancyOptions = [
    { key: "all", label: "All" },
    { key: "OCCUPIED", label: "Occupied" },
    { key: "TO_BE_OCCUPIED", label: "To be occupied" },
    { key: "UNOCCUPIED", label: "Unoccupied" },
];
exports.occupancyOptions = occupancyOptions;
var rowsPerPageOptions = [
    { key: "10", label: "10" },
    { key: "25", label: "25" },
    { key: "50", label: "50" },
    { key: "100", label: "100" },
];
exports.rowsPerPageOptions = rowsPerPageOptions;
var areaCategoryOptions = [
    { key: "Leasable Area", label: "Leasable Area" },
    { key: "Landlord Public Area", label: "Landlord Public Area" },
    { key: "Landlord Non-Public Area", label: "Landlord Non-Public Area" },
    { key: "Service Area", label: "Service Area" },
    // ATOC-1 A8: available for every area type.
    { key: "Sewage Treatment Plant", label: "Sewage Treatment Plant" },
];
exports.areaCategoryOptions = areaCategoryOptions;
/**
 * ATOC-1 B1h: shown under the category buttons once one is picked.
 *
 * These are the definitions that currently sit under the tick boxes in the Access & Leaseability
 * section — that section is being merged away, so the wording moves here rather than being lost.
 */
var areaCategoryDescriptions = {
    "Leasable Area": "Can be let to a tenant and billed. Counts towards the asset's GLA.",
    "Landlord Public Area": "Open to the public but not lettable — malls, walkways, parking, ablutions.",
    "Landlord Non-Public Area": "Back-of-house space the landlord controls — plant rooms, stores, workshops.",
    "Service Area": "Houses plant or services rather than people. Never leasable, never public.",
    "Sewage Treatment Plant": "On-site sewage treatment infrastructure serving the asset.",
};
exports.areaCategoryDescriptions = areaCategoryDescriptions;
// ─── Area Sub-Type Mappings ─────────────────────────────────────────────────
// Organized by: areaType → areaCategory → sub-types[]
var areaSubTypeMap = {
    // ── Retail ────────────────────────────────────────────────────────────────
    Retail: {
        "Leasable Area": [
            "Shop",
            "Anchor Shop",
            "ATM",
            "Kiosk",
            "Hawker Stall",
            "Market Stall",
            "Food Court Unit",
            "Restaurant",
            "Drive-Through",
            "Car Wash",
            "Vending Machine Area",
            "Office",
            "Service Desk",
            "Pop-Up Store",
            "Storage Area",
        ],
        "Landlord Public Area": [
            "Common Area",
            "Walkway",
            "Entrance Lobby",
            "Public Rest Room",
            "Toilet",
            "Bathroom",
            "Signage Area",
            "Parking Area",
            "Driveway",
            "Pedestrian Access",
            "Receiving Area",
            "Delivery Yard",
            "Landscaping Area",
            "Irrigation Area",
            "Centre Management Office",
        ],
        "Landlord Non-Public Area": [
            "Control Room",
            "Security Room",
            "Pump Room",
            "Generator Area",
            "Fuel Storage Area",
            "Solar Area",
            "Inverter Room",
            "BESS Area",
            "Water Tank Area",
            "Fire Tank Area",
            "Fire Pump Room",
            "Refuse Area",
            "Electrical Room",
            "Main Distribution Board Room",
            "Meter Room",
            "Communications Room",
            "Maintenance Workshop",
            "Staff Change Room",
        ],
    },
    // ── Residential ───────────────────────────────────────────────────────────
    Residential: {
        "Leasable Area": [
            "Apartment",
            "Flat",
            "Studio Unit",
            "Townhouse",
            "Duplex",
            "Penthouse",
            "Loft Unit",
            "Student Room",
            "Serviced Apartment",
            "Granny Flat",
            "Private Balcony",
            "Patio",
            "Terrace",
            "Private Garden",
            "Storage Cage",
            "Store Room",
            "Private Garage",
            "Carport",
            "Allocated Parking Bay",
        ],
        "Landlord Public Area": [
            "Entrance Lobby",
            "Lift Lobby",
            "Corridor",
            "Stairwell",
            "Shared Laundry",
            "Mail Room",
            "Visitor Parking",
            "Driveway",
            "Communal Garden",
            "Courtyard",
            "Playground",
            "Swimming Pool",
            "Barbeque Area",
            "Clubhouse",
            "Gym",
            "Walkways",
        ],
        "Landlord Non-Public Area": [
            "Electrical Room",
            "Main DB Room",
            "Meter Room",
            "Water Meter Room",
            "Pump Room",
            "Fire Pump Room",
            "Water Tank Area",
            "Fire Tank Area",
            "Generator Area",
            "Solar Area",
            "BESS Area",
            "Communications Room",
            "Maintenance Workshop",
            "Janitor Store",
            "Security Control Room",
            "Staff Facilities",
        ],
    },
    // ── Industrial ────────────────────────────────────────────────────────────
    Industrial: {
        "Leasable Area": [
            "Warehouse",
            "Storage Hall",
            "Factory Floor",
            "Production Area",
            "Assembly Area",
            "Packaging Area",
            "Workshop",
            "Maintenance Bay",
            "Cold Room",
            "Freezer",
            "Bulk Storage Area",
            "Racking Area",
            "Bonded Warehouse",
            "Testing Area",
            "Quality Control Area",
            "Tenant Office",
            "Control Room (Tenant-Specific)",
            "Exclusive Yard Area",
            "Exclusive Loading Dock",
        ],
        "Landlord Public Area": [
            "Shared Loading Yard",
            "Shared Truck Staging Area",
            "Internal Roads",
            "Shared Parking",
            "Guard House",
            "Fire Assembly Area",
            "Weighbridge Area",
        ],
        "Landlord Non-Public Area": [
            "Main Electrical Substation",
            "HV Switch Room",
            "MV Switch Room",
            "Transformer Yard",
            "Generator Yard",
            "Fuel Storage Area",
            "Boiler Room",
            "Compressed Air Plant",
            "Cooling Tower Area",
            "Effluent Treatment Plant",
            "Water Reservoir Area",
            "Fire Tank Area",
            "Pump Room",
            "Solar Plant Area",
            "BESS Yard",
            "Security Control Room",
        ],
    },
    // ── Hospitality (ATOC-1 A3: was "Hotel & Resort") ─────────────────────────
    Hospitality: {
        "Leasable Area": [
            "Guest Room",
            "Suite",
            "Family Room",
            "Villa",
            "Chalet",
            "Lodge Unit",
            "Timeshare Unit",
            "Conference Room",
            "Banquet Hall",
            "Restaurant",
            "Bar",
            "Lounge",
            "Coffee Shop",
            "Retail Boutique",
            "Spa Treatment Room",
            "Salon",
            "Casino Area",
        ],
        "Landlord Public Area": [
            "Reception",
            "Front Desk",
            "Lobby Lounge",
            "Corridors",
            "Lift Lobbies",
            "Stairwells",
            "Swimming Pool",
            "Pool Deck",
            "Gym",
            "Kids Club",
            "Games Room",
            "Beach Access Area",
            "Viewing Deck",
            "Gardens",
            "Parking Areas",
            "Jetty",
            "Marina",
        ],
        "Landlord Non-Public Area": [
            "Housekeeping Store",
            "Linen Room",
            "Laundry",
            "Main Kitchen",
            "Prep Kitchen",
            "Cold Rooms",
            "Freezers",
            "Staff Canteen",
            "Staff Change Rooms",
            "Staff Accommodation",
            "Maintenance Workshop",
            "HVAC Plant Room",
            "Generator Area",
            "Fuel Storage",
            "Electrical Room",
            "Water Treatment Plant",
            "Borehole Area",
            "Sewerage Package Plant",
            "Solar Area",
            "BESS Area",
            "Security Control Room",
        ],
    },
    // ── Commercial ────────────────────────────────────────────────────────────
    Commercial: {
        "Leasable Area": [
            "Office Suite",
            "Floor Plate",
            "Shared Office",
            "Co-working Space",
            "Boardroom",
            "Training Room",
            "Consulting Room",
            "Medical Suite",
            "Call Centre Floor",
            "Archive Room",
            "Filing Room",
            "Storage Unit",
            "Server Room (Tenant)",
            "Private Balcony",
            "Terrace",
            "Exclusive Parking Bay",
        ],
        "Landlord Public Area": [
            "Main Lobby",
            "Reception Area",
            "Lift Lobby",
            "Stairwell",
            "Corridor",
            "Shared Kitchenette",
            "Shared Restrooms",
            "Shared Boardrooms",
            "Courtyard",
            "Outdoor Seating Area",
            "Shared Parking",
            "Cafe",
            "Ground-Floor Retail Unit",
        ],
        "Landlord Non-Public Area": [
            "Electrical Room",
            "Main Distribution Board Room",
            "Generator Room",
            "UPS Room",
            "HVAC Plant Room",
            "Chiller Plant",
            "Cooling Towers",
            "Water Tank Area",
            "Fire Pump Room",
            "IT Room",
            "Communications Room",
            "Security Control Room",
            "Cleaning Store",
            "Refuse Room",
            "Solar Area",
            "BESS Area",
        ],
    },
    // ── Sports & Recreation ───────────────────────────────────────────────────
    "Sports & Recreation": {
        "Leasable Area": [
            "Indoor Sports Hall",
            "Gym Floor",
            "Aerobics Studio",
            "Swimming Pool",
            "Ice Rink",
            "Squash Court",
            "Tennis Court",
            "Badminton Court",
            "Basketball Court",
            "Soccer Field",
            "Rugby Field",
            "Cricket Nets",
            "Go-Kart Track",
            "Driving Range",
            "Climbing Wall",
            "Shooting Range",
            "Bowling Lanes",
            "Pro Shop",
            "Food Court Unit",
            "VIP Box",
            "Sky Suite",
        ],
        "Landlord Public Area": [
            "Grandstands",
            "Spectator Seating",
            "Concourse",
            "Ticketing Area",
            "Turnstiles",
            "Public Restrooms",
            "Food and Beverage Concessions",
            "Fan Zones",
            "Parking Areas",
            "Drop-off Zones",
            "Pedestrian Walkways",
        ],
        "Landlord Non-Public Area": [
            "Change Rooms",
            "Referee Rooms",
            "Medical Room",
            "First Aid Room",
            "Doping Control Room",
            "Equipment Store",
            "Groundskeeping Store",
            "Control Room (Lighting and AV)",
            "Broadcast Room",
            "Electrical Room",
            "Generator Area",
            "Water Pump Room",
            "Fire Tank Area",
            "Solar Area",
            "BESS Area",
            "Security Control Room",
        ],
    },
};
exports.areaSubTypeMap = areaSubTypeMap;
// ── Service Area Sub-Types (common across all building types) ────────────────
// These are always non-leasable and non-public.
var serviceAreaSubTypes = [
    // Mechanical Plant
    "HVAC Plant Room",
    "Chiller Room",
    "Cooling Tower Platform",
    "Air Handling Unit (AHU) Room",
    "Compressor Room",
    "Generator Room",
    "Fuel Storage Room",
    "Water Treatment Room",
    "Fire Pump Room",
    // Electrical Plant
    "Transformer Room",
    "Switchgear Room",
    "Main Distribution Board (MDB) Room",
    "Sub-DB Room",
    "UPS Room",
    "Battery Room",
    "Metering Room",
    "Solar Inverter Room",
    "BMS Control Room",
    // Fire & Safety
    "Fire Control Room",
    "Sprinkler Valve Room",
    "Hose Reel Cabinet Area",
    "Smoke Extraction Fan Room",
    "Emergency Generator Enclosure",
    // Water & Plumbing
    "Water Tank Room",
    "Borehole Pump Room",
    "Sewer Lift Station",
    "Greywater Plant Room",
    "Irrigation Pump Room",
    "Water Meter Chamber",
    // Operational / Back-Of-House
    "Service Corridors",
    "Loading Bay",
    "Refuse Room",
    "Waste Compactor Room",
    "Storage Rooms",
    "Maintenance Workshop",
    "Janitor's Closet",
    "Security Control Room",
    // Vertical Circulation & Shared Core
    "Lift Shaft",
    "Lift Motor Room",
    "Escalator Machinery Space",
    "Fire Escape Stairwell",
    "Common Lobby Core",
    // Roof Space
    "Solar Panel Area",
];
exports.serviceAreaSubTypes = serviceAreaSubTypes;
/**
 * Returns the list of sub-type options for the given areaType + areaCategory combination.
 * For "Service Area" category, returns the common service area sub-types regardless of building type.
 */
function getAreaSubTypes(areaType, areaCategory, isCustomAsset) {
    var _a;
    if (isCustomAsset === void 0) { isCustomAsset = false; }
    // ATOC-1 A4: a CUSTOM asset unlocks every sub-type, not just one type's set — "the 'Custom' makes
    // all of the area categories for all area sub-types available".
    //
    // This is keyed on the ASSET being CUSTOM, not the area type. "Custom" is not one of the eight area
    // types and can never be selected as one, so the earlier `areaType === "Custom"` test was
    // unreachable and the unlock never happened.
    if (isCustomAsset) {
        var all_1 = new Set(serviceAreaSubTypes);
        for (var _i = 0, _b = Object.values(areaSubTypeMap); _i < _b.length; _i++) {
            var byCategory = _b[_i];
            for (var _c = 0, _d = Object.values(byCategory); _c < _d.length; _c++) {
                var subTypes = _d[_c];
                subTypes.forEach(function (s) { return all_1.add(s); });
            }
        }
        return Array.from(all_1).sort(function (a, b) { return a.localeCompare(b); });
    }
    if (areaCategory === "Service Area") {
        return serviceAreaSubTypes;
    }
    // ATOC-1 A8: a treatment plant is plant, so it draws on the same service-area sub-types rather
    // than needing its own list duplicated across every area type.
    if (areaCategory === "Sewage Treatment Plant") {
        return serviceAreaSubTypes;
    }
    return ((_a = areaSubTypeMap[areaType]) === null || _a === void 0 ? void 0 : _a[areaCategory]) || [];
}
